import React, { useContext } from "react";
import { DirectionRight } from "@/Icons";
import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import GlobalContext from "models/globalContext";
import { UserTypeEnum } from "@/api/dmp_common/interface";

const toolList = [
  {
    title: "下载中心",
    desc: "批量快速下载数据",
    icon: "https://commimg.pddpic.com/upload/dmp/home_download.png.slim.png",
    code: ResourceCodeEnums.DOWNLOAD_CENTER,
  },
  {
    title: "拼多多推广平台",
    desc: "助力生意增长",
    icon: "https://commimg.pddpic.com/upload/dmp/home_tool.png.slim.png",
    url: "https://yingxiao.pinduoduo.com/",
  },
];

const toolListForBrandAccount = [
  {
    title: "下载中心",
    desc: "批量快速下载数据",
    icon: "https://commimg.pddpic.com/upload/dmp/home_download.png.slim.png",
    code: ResourceCodeEnums.DOWNLOAD_CENTER,
  },
  {
    title: "操作记录",
    desc: "查询账户内历史操作记录",
    icon: "https://commimg.pddpic.com/upload/dmp/op_his.png.slim.png",
    code: ResourceCodeEnums.OPERATION_LOG,
  },
];

const Tool = () => {
  const { userType } = useContext(GlobalContext);
  const handleJump = () => {
    window.open(`/${ResourceCodeEnums.TOOL}`);
  };

  const handleJumpToTool = (item) => {
    if (item.url) {
      window.open(item.url);
    }
    if (item.code) {
      window.open(`/${ResourceCodeEnums.TOOL}/${item.code}`);
    }
  };

  return (
    <div className="h-full rounded-lg bg-white p-6">
      <div className="title mb-6 overflow-hidden">
        <span className="text-base font-semibold leading-8">工具</span>
        <div className="title-tools float-right flex">
          <span
            className="dmp-link ml-4 flex h-8 cursor-pointer items-center text-text-black/[.65]"
            onClick={handleJump}
          >
            查看全部
            <DirectionRight />
          </span>
        </div>
      </div>

      <div>
        <ul className="flex flex-col gap-3">
          {(UserTypeEnum.BRAND === userType
            ? toolListForBrandAccount
            : toolList
          ).map((item) => (
            <li
              key={item.title}
              className="flex cursor-pointer items-center gap-4"
              onClick={() => handleJumpToTool(item)}
            >
              <img src={item.icon} className="h-[56px] w-[56px] rounded" />
              <div className="flex-1 text-sm">
                <div className="dmp-link mb-1 font-semibold">{item.title}</div>
                <div className="text-text-black/[.5]">{item.desc}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Tool;
